import { render, staticRenderFns } from "./config.vue?vue&type=template&id=640fdf85&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"
import style0 from "./config.vue?vue&type=style&index=0&id=640fdf85&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640fdf85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640fdf85')) {
      api.createRecord('640fdf85', component.options)
    } else {
      api.reload('640fdf85', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=640fdf85&scoped=true", function () {
      api.rerender('640fdf85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/logistics/strategy/config.vue"
export default component.exports